<div class="currencies" *ngIf="initialized">
    <div
        class="crypto-wallet"
        *ngFor="
            let currencies of currenciesData | keyvalue : walletOrder;
            trackBy: trackCryptoCurrencies
        "
    >
    @defer(on viewport){
        <div *ngIf="currencies.value.length">
            <p
                class="text text--size-s text--color-secondary crypto-wallet__name"
            >
                {{ cryptoWalletsName[currencies.key] }}
            </p>
            <div
                class="currency"
                *ngFor="
                    let currency of currencies.value;
                    trackBy: trackCurrencies
                "
                (click)="onCurrencyClick(currency)"
            >
                <div class="currency__icon-wrapper">
                    <img
                        *ngIf="currency.icon"
                        class="currency__icon"
                        src="{{ currency.icon }}"
                    />
                    <p *ngIf="!currency.icon" class="title currency__no-icon">
                        {{ currency.symbol.slice(0, 3) }}
                    </p>
                    <img
                        *ngIf="currency.platform_icon"
                        class="currency__icon--platform prevent-theme-dark"
                        src="{{ currency.platform_icon }}"
                    />
                    <p
                        *ngIf="!currency.platform_icon"
                        style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        "
                        class="currency__icon--platform prevent-theme-dark text--size-s text--color-secondary"
                    >
                        {{ currency.blockchain.slice(0, 3) }}
                    </p>
                </div>
                <div class="currency_inner">
                    <div class="top">
                        <div class="title currency__name">
                            {{ currency.name }}
                        </div>
                        <div class="title currency__balance font-roboto-mono">
                            {{ currency.balance }}
                            {{ currency.symbol.slice(0, 5) }}
                        </div>
                    </div>
                    <div class="bottom">
                        <div
                            class="text text--color-secondary text--size-s font-roboto-mono"
                        >
                            {{ currency.price }} USD
                        </div>
                        <div
                            class="text text--color-secondary text--size-s font-roboto-mono"
                        >
                            {{ currency.price_amount }} USD
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }@placeholder {
        <p class="text text--center text--size-l text--color-secondary">
            {{ "COMMON.LOADING" | translate }}...
        </p>
    }
    </div>
</div>
